module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-black.4ceceaac.svg";